import { render, staticRenderFns } from "./wonFailedDialog.vue?vue&type=template&id=678f829e&"
import script from "./wonFailedDialog.vue?vue&type=script&lang=js&"
export * from "./wonFailedDialog.vue?vue&type=script&lang=js&"
import style0 from "./wonFailedDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports